import { AnimatePresence, motion } from "motion/react";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Button from "@/components/buttons/Button";
import DetailFavoriteButton from "@/components/detail/DetailFavoriteButton";

import { ROUTES } from "@/config/routes";
import { useGetContentDetail } from "@/hooks/api/content.hooks";

import MoviePreviewVideo from "./MoviePreviewVideo/MoviePreviewVideo";

const MovieCardPreview = ({ id, width, previewImg }: { id: number; width: number; previewImg: string }) => {
  const { t } = useTranslation();
  const [isBeingHidden, setIsBeingHidden] = useState<boolean>(false);

  const { data: content, isLoading } = useGetContentDetail(id);

  const token = localStorage.getItem("splay:token") || "";

  const scrollEvent = () => {
    setIsBeingHidden(true);
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollEvent);

    return () => {
      window.removeEventListener("scroll", scrollEvent);
    };
  }, [isBeingHidden]);

  return (
    <div
      style={{ width: width }}
      onMouseOver={() => setIsBeingHidden(false)}
      onMouseOut={() => setIsBeingHidden(true)}
      className="w-full overflow-clip rounded-[0.75rem] "
    >
      <MoviePreviewVideo previewImg={previewImg} isBeingHidden={isBeingHidden} id={id} />

      <motion.div
        initial={{ opacity: 0 }}
        exit={{ opacity: 0, animationDelay: "200ms" }}
        animate={{ opacity: 1 }}
        className="relative z-10 bg-surface-bright p-[0.6rem]"
      >
        <AnimatePresence mode="wait">
          {!isLoading && content ? (
            <motion.div initial={{ opacity: 0 }} exit={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <h3 className="mb-[0.1rem] text-[0.75rem] font-semibold">{content.title}</h3>
              <div className="mb-2 flex flex-wrap gap-[0.313rem] text-[0.5625rem] text-[#C7C6C6]">
                {content.year && <span>{content.year}</span>}
                {content.country[0] && <span>{content.country[0].name}</span>}
                {content.genres[0] && <span>{content.genres[0].name}</span>}
                <span>{content.age_restrictions}+</span>
              </div>
              <div className="flex gap-3">
                <Link to={ROUTES.DETAIL.MAIN.replace(":id", content!.id.toString())}>
                  <Button
                    size={"medium"}
                    title={t("Actions.start-watching")}
                    className={"h-7 w-[8rem] text-nowrap p-1 text-xs"}
                  >
                    {t("Actions.watch")}
                  </Button>
                </Link>

                {token && <DetailFavoriteButton id={content.id} />}
              </div>
            </motion.div>
          ) : (
            <>
              <div className="mb-2 h-4 w-[70%] animate-pulse rounded-full bg-surface-container-high"></div>
              <div className="mb-2 h-4 w-14 animate-pulse rounded-full bg-surface-container-high"></div>
              <div className="h-5 w-20 animate-pulse rounded-full bg-surface-container-high"></div>
            </>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};

export default MovieCardPreview;
